import { ChartType } from "types";
import { AuditStatus } from "../types";

type ChartAuditType = "Nurse" | "Provider" | "";

type AuditStatusData = {
  nurseChartAuditStatus?: AuditStatus;
  providerChartAuditStatus?: AuditStatus;
};

function mapChartTypeToAuditType(
  chartType: ChartType | undefined
): ChartAuditType {
  if (chartType === "Triage") return "Nurse";
  if (chartType === "Chart") return "Provider";
  return "";
}

function getAuditStatusForChartType(
  data: AuditStatusData | undefined,
  chartType: ChartAuditType
): AuditStatus | undefined {
  if (chartType === "Nurse") return data?.nurseChartAuditStatus;
  if (chartType === "Provider") return data?.providerChartAuditStatus;
  return undefined;
}

export type { ChartAuditType, AuditStatusData };
export { mapChartTypeToAuditType, getAuditStatusForChartType };
